"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SettingsService = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Api = _interopRequireDefault(require("../Api"));
var _excluded = ["token", "path", "op"],
  _excluded2 = ["token"],
  _excluded3 = ["token", "tenantId"],
  _excluded4 = ["token", "tenantId", "id"],
  _excluded5 = ["token", "tenantId", "id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SettingsService = exports.SettingsService = /*#__PURE__*/(0, _createClass2["default"])(function SettingsService() {
  (0, _classCallCheck2["default"])(this, SettingsService);
});
(0, _defineProperty2["default"])(SettingsService, "editCurrentUser", function (_ref) {
  var token = _ref.token,
    path = _ref.path,
    _ref$op = _ref.op,
    op = _ref$op === void 0 ? 'edit' : _ref$op,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return _Api["default"].withAuth(token).post("/user/".concat(op, "/").concat(path), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(SettingsService, "changeStaffPassword", function (_ref2) {
  var token = _ref2.token,
    params = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return _Api["default"].withAuth(token).post('/auth/resetPassword', _objectSpread({}, params));
});
(0, _defineProperty2["default"])(SettingsService, "listPricerByCondoId", function (_ref3) {
  var token = _ref3.token,
    tenantId = _ref3.tenantId,
    params = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
  return _Api["default"].withAuth(token, tenantId).get("/management/pricer", {
    params: params
  });
});
(0, _defineProperty2["default"])(SettingsService, "createIntervalPriceTableOnPricer", function (_ref4) {
  var token = _ref4.token,
    tenantId = _ref4.tenantId,
    id = _ref4.id,
    params = (0, _objectWithoutProperties2["default"])(_ref4, _excluded4);
  return _Api["default"].withAuth(token, tenantId).post("/management/pricer/".concat(id, "/priceTables/add/IntervalAndPeriodPriceTables"), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(SettingsService, "updateIntervalPriceTableOnPricer", function (_ref5) {
  var token = _ref5.token,
    tenantId = _ref5.tenantId,
    id = _ref5.id,
    params = (0, _objectWithoutProperties2["default"])(_ref5, _excluded5);
  return _Api["default"].withAuth(token, tenantId).patch("/management/pricer/".concat(id, "/priceTables/update/IntervalAndPeriodPriceTables"), _objectSpread({}, params));
});